import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface CollectionCalendarDayBucket {
  date: string;
  chargeCount: number;
  totalAmount: number;
}

export interface CollectionCalendarKpis {
  chargeCount: number;
  totalAmount: number;
}

export interface CollectionCalendarForecast {
  from: string;
  to: string;
  kpis: CollectionCalendarKpis;
  days: CollectionCalendarDayBucket[];
}

interface CollectionCalendarApi {
  from?: string;
  to?: string;
  kpis?: Partial<CollectionCalendarKpis>;
  days?: { date?: string; chargeCount?: number; totalAmount?: number }[];
}

interface WrapperCollectionCalendar {
  ok?: boolean;
  message?: string;
  body?: CollectionCalendarApi | null;
}

@Injectable({ providedIn: 'root' })
export class ForecastCollectionCalendarService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  getCalendar(from: string, to: string): Observable<WrapperCollectionCalendar> {
    const params = new HttpParams().set('from', from).set('to', to);
    return this.http.get<WrapperCollectionCalendar>(`${this.apiUrl}/forecasts/collection-calendar`, { params });
  }
}

export function mapCollectionCalendar(body: CollectionCalendarApi | null | undefined): CollectionCalendarForecast {
  const days = (body?.days ?? []).map((d) => ({
    date: (d.date ?? '').slice(0, 10),
    chargeCount: Number(d.chargeCount ?? 0),
    totalAmount: Number(d.totalAmount ?? 0)
  }));
  return {
    from: (body?.from ?? '').slice(0, 10),
    to: (body?.to ?? '').slice(0, 10),
    kpis: {
      chargeCount: Number(body?.kpis?.chargeCount ?? days.reduce((s, d) => s + d.chargeCount, 0)),
      totalAmount: Number(body?.kpis?.totalAmount ?? days.reduce((s, d) => s + d.totalAmount, 0))
    },
    days
  };
}
